import { render, staticRenderFns } from "./IQThinkingDropdown.vue?vue&type=template&id=bf00815a&scoped=true"
import script from "./IQThinkingDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./IQThinkingDropdown.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQThinkingDropdown.vue?vue&type=style&index=0&id=bf00815a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf00815a",
  null
  
)

export default component.exports